module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"aboutCompany":"Company"}}')
  delete Component.options._Ctor
}
